module.exports = __webpack_public_path__ + "img/mflogo.5957a41f.svg";